import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const COLORS = [
  { name: 'White', path: '/', hex: '#ffffff' },
  { name: 'Black', path: '/black-screen', hex: '#000000' },
  { name: 'Red', path: '/red-screen', hex: '#ff0000' },
  { name: 'Green', path: '/green-screen', hex: '#00cc00' },
  { name: 'Blue', path: '/blue-screen', hex: '#0055ff' },
  { name: 'Yellow', path: '/yellow-screen', hex: '#ffee00' },
  { name: 'Purple', path: '/purple-screen', hex: '#8800cc' },
  { name: 'Orange', path: '/orange-screen', hex: '#ff6600' },
  { name: 'Pink', path: '/pink-screen', hex: '#ff66aa' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [colorDropOpen, setColorDropOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setColorDropOpen(false);
    document.body.style.overflow = '';
  }, [location]);

  const toggleMenu = () => {
    setMenuOpen(o => { document.body.style.overflow = !o ? 'hidden' : ''; return !o; });
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container nav-inner">
          <Link to="/" className="nav-logo">
            <span className="logo-icon">⬜</span>
            <span>White<span className="accent">Screen</span></span>
          </Link>
          <div className="nav-center">
            <div className="color-dropdown" onMouseEnter={() => setColorDropOpen(true)} onMouseLeave={() => setColorDropOpen(false)}>
              <button className="nav-link drop-btn">
                🎨 Colors
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
              </button>
              {colorDropOpen && (
                <div className="drop-menu">
                  {COLORS.map(c => (
                    <Link key={c.path} to={c.path} className="drop-item">
                      <span className="drop-swatch" style={{ background: c.hex, border: c.hex === '#ffffff' ? '1px solid #e5e7eb' : 'none' }} />
                      {c.name} Screen
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link to="/white-noise" className={`nav-link ${location.pathname === '/white-noise' ? 'active' : ''}`}>🔊 White Noise</Link>
            <Link to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}>About</Link>
            <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>Contact</Link>
          </div>
          <div className="nav-right">
            <Link to="/black-screen" className="nav-btn-outline">🌙 Dark Mode</Link>
            <button className="hamburger" onClick={toggleMenu}>
              <span className={menuOpen ? 'open' : ''} />
              <span className={menuOpen ? 'open' : ''} />
              <span className={menuOpen ? 'open' : ''} />
            </button>
          </div>
        </div>
      </nav>
      <div className={`mobile-nav ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-section">
          <div className="mobile-section-title">Screen Colors</div>
          {COLORS.map(c => (
            <Link key={c.path} to={c.path} className="mobile-link">
              <span className="drop-swatch" style={{ background: c.hex, border: c.hex === '#ffffff' ? '1px solid #e5e7eb' : 'none' }} />
              {c.name} Screen
            </Link>
          ))}
        </div>
        <div className="mobile-divider" />
        <Link to="/white-noise" className="mobile-link">🔊 White Noise</Link>
        <Link to="/about" className="mobile-link">About</Link>
        <Link to="/contact" className="mobile-link">Contact</Link>
      </div>
    </>
  );
}
